/** Pickable Overview tab widgets (all-time ESG + optional charts). */
export type EsgOverviewWidgetId =
  | 'summary_waste_diverted'
  | 'summary_diversion_rate'
  | 'summary_total_co2'
  | 'summary_fill_reports'
  | 'summary_training_hours'
  | 'summary_health_safety'
  | 'scope_1'
  | 'scope_2'
  | 'utility_water'
  | 'utility_electricity'
  | 'utility_oil'
  | 'utility_gas'
  | 'chart_recycled'
  | 'chart_incoming'
  | 'chart_carbon_stream'
  | 'chart_carbon_material';

export const ESG_OVERVIEW_WIDGET_LABELS: Record<EsgOverviewWidgetId, string> = {
  summary_waste_diverted: 'Waste collected via platform',
  summary_diversion_rate: 'Pickup completion rate (by mass)',
  summary_total_co2: 'Avoided emissions',
  summary_fill_reports: 'Fill-level reports',
  summary_training_hours: 'Training hours',
  summary_health_safety: 'Health & safety',
  scope_1: 'Scope 1 emissions',
  scope_2: 'Scope 2 emissions',
  utility_water: 'Water',
  utility_electricity: 'Electricity',
  utility_oil: 'Oil',
  utility_gas: 'Gas',
  chart_recycled: 'Waste composition by type & material (chart)',
  chart_incoming: 'Incoming waste breakdown (chart)',
  chart_carbon_stream: 'Avoided emissions by material (chart)',
  chart_carbon_material: 'Avoided emissions by category (table)',
};

/** Display / dialog order: summaries (diverted first), then utilities, then charts. */
export const PICKABLE_ESG_OVERVIEW_WIDGETS: EsgOverviewWidgetId[] = [
  'summary_waste_diverted',
  'summary_fill_reports',
  'summary_diversion_rate',
  'summary_total_co2',
  'summary_training_hours',
  'summary_health_safety',
  'scope_1',
  'scope_2',
  'utility_water',
  'utility_electricity',
  'utility_oil',
  'utility_gas',
  'chart_recycled',
  'chart_incoming',
  'chart_carbon_stream',
];

export const DEFAULT_ESG_OVERVIEW_WIDGETS: EsgOverviewWidgetId[] = [
  ...PICKABLE_ESG_OVERVIEW_WIDGETS,
];
